module.exports = __webpack_public_path__ + "img/reward-input.ab88927e.png";